'use strict';
export class ColorTextHTML {
    constructor(token) {
        this.validColors = ['blue', 'gray', 'red', 'green', 'yellow', 'purple', 'pink', 'indigo'];
        this.token = token;
    }
    render(childrenHtml = "") {
        const color = this.validColors.includes(this.token.color) ? this.token.color : 'gray';
        const escapedValue = this.token.value
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
        return `<span><a class="md-color-text md-color-text-${color}">${escapedValue}</a> ${childrenHtml}</span>`;
    }
}
